import SamplesTable from './SamplesTable';
import SamplesColumns from './SamplesColumns';
import SamplesRows from './SamplesRows';

export default SamplesTable;
export {
  SamplesColumns,
  SamplesRows
};
